import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  organization: Yup.number().notOneOf([0], 'Şirket zorunludur.'),
  first_name: Yup.string().required('İsim zorunludur.'),
  last_name: Yup.string().required('Soyisim zorunludur.'),
  turkish_id: Yup.string()
    .required('TCKN zorunludur.')
    .matches(/^\d{11}$/, 'TCKN 11 haneli olmalıdır.'),
});

export default validationSchema;
